/* global axios */

// WEXHUB: alta y baja de plantillas de WhatsApp contra Meta.
import ApiClient from './ApiClient';

class WhatsappTemplates extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  templatesUrl(inboxId) {
    return `${this.url}/${inboxId}/whatsapp_templates`;
  }

  getTemplates(inboxId) {
    return axios.get(this.templatesUrl(inboxId));
  }

  createTemplate(inboxId, template) {
    return axios.post(this.templatesUrl(inboxId), { template });
  }

  deleteTemplate(inboxId, name) {
    return axios.delete(
      `${this.templatesUrl(inboxId)}/${encodeURIComponent(name)}`
    );
  }
}

export default new WhatsappTemplates();
